import { render } from "./AlertDialog.vue?vue&type=template&id=0ca90eb7&scoped=true"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"

import "./AlertDialog.vue?vue&type=style&index=0&id=0ca90eb7&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca90eb7"]])

export default __exports__